class SpecialProductsSlide extends HTMLElement {
  constructor() {
    super();

    this.initSlide();
  }

  initSlide() {

    const slide = $(this).slick({
      slidesToShow: 2,
      arrows: false,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

customElements.define('special-products-slide', SpecialProductsSlide);